import { RESET_FORM_DATA, SET_FORM_DATA } from "../actions/types";

const initialState = {
    formData: null
};

const forgotReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORM_DATA:
            return { ...state, formData: action.payload };
        case RESET_FORM_DATA:
            return { ...state, formData: null };
        default:
            return state;
    }
};

export default forgotReducer;